<template>
  <div class="product_brand">
    <div class="product_content">
      <div class="Classification">
        <div class="ClassificationItem" @click="changGroup(index,item.id)" v-for="(item,index) in GroupList"
             :key="index">
          <div>{{ item.name }}</div>
          <div :class="{'active_class':groupIndex==index}" class="activ_line"></div>
        </div>
      </div>
      <div class="cutr_content">
        <div class="in_for_tan animate__animated animate__slow"  :class="{'animate__fadeInUp':item.anmintes}" v-for="(item,index) in productList" :key="index">
          <div class="foy_item">
            <div class="img_box">
              <div class="names">{{ item.name }}</div>
              <div class="txt_lines"></div>
            </div>
            <div class="lines"></div>
            <div class="intro">
              <div class="tips">药品信息：</div>
              <div class="intro_mess tbs">
                <span>规格：{{ item.spec }}</span>
              </div>
              <div class="intro_mess tuns many-txt-line" :class="{'active_tuns':item.chengNum}">{{ item.intro }}</div>
            </div>
            <div class="see">
              <img @click="changHeight(index)" v-if=" item.clickou" class="img" src="../../assets/product/see.png"/>
              <img @click="changUnHeight(index)" v-else class="active_img" src="../../assets/product/active_op.png"/>
            </div>
          </div>
        </div>
      </div>
      <div class="block_pagination block_pc" v-if="total">
        <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-size="6"
            :pager-count="7"
            layout="prev, pager, next, total,jumper"
            :total="total">
        </el-pagination>
      </div>
      <div class="block_pagination block_wap" v-if="total">
        <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-size="6"
            :pager-count="5"
            layout="prev, pager, next"
            :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {getGroupList, getProductMoreList} from "../../api/apis";

export default {
  name: "brand",
  data() {
    return {
      groupIndex: 0,
      group_id: '',
      productList: [],
      GroupList: [],
      page: 1,
      total: 0,
    }
  },
  mounted() {
    this.getBanner()
    window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      let scroll = document.documentElement.scrollTop || document.body.scrollTop;
      if (document.body.clientWidth < 1200) {

      }else {
        if (scroll > 135) {
          if( this.productList[0]){
            this.productList[0].anmintes = true
          }
        }
        if (scroll > 384) {
          if( this.productList[1]){
            this.productList[1].anmintes = true
          }
        }
        if (scroll > 638) {
          if( this.productList[2]){
            this.productList[2].anmintes = true
          }
        }
        if (scroll > 890) {
          if( this.productList[3]){
            this.productList[3].anmintes = true
          }
        }
        if (scroll > 1136) {
          if( this.productList[4]){
            this.productList[4].anmintes = true
          }
        }
        if (scroll > 1384) {
          if( this.productList[5]){
            this.productList[5].anmintes = true
          }
        }
      }
      //   this.showNowBtn = true;
      // }
      // if (scroll > 4000) {
      //   this.showSurvey = true;
      // }
      // if (document.body.clientWidth < 1200) {
      //   if (scroll > 2300) {
      //     this.showSurvey = true;
      //   }
      // }
    },
    handleCurrentChange(e) {
      this.page = e
      // this.GetProductList()
      let datas = {
        group_id: this.group_id,
        name: '',
        page: this.page,
        limit: 6
      }
      getProductMoreList(datas).then(res => {
        res.data.data.map(item => {
          item.chengNum = false
          item.anmintes = true
          if (item.intro.length >= 83) {
            item.clickou = true
          } else {
            item.clickou = false
          }
        })
        this.productList = res.data.data
        this.total = res.data.total
      })
    },
    changHeight(e) {
      this.productList[e].chengNum = true
      this.productList[e].clickou = !this.productList[e].clickou
    },
    changUnHeight(e) {
      this.productList[e].chengNum = false
      if (this.productList[e].intro.length>=83) {
        this.productList[e].clickou = !this.productList[e].clickou
      }
    },
    changGroup(e, id) {
      this.groupIndex = e
      this.group_id = id
      // this.GetProductList()
      let datas = {
        group_id: this.group_id,
        name: '',
        page: this.page,
        limit: 6
      }
      getProductMoreList(datas).then(res => {
        res.data.data.map(item => {
          item.chengNum = false
          item.anmintes = true
          if (item.intro.length >= 83) {
            item.clickou = true
          } else {
            item.clickou = false
          }
        })
        this.productList = res.data.data
        this.total = res.data.total
      })
    },
    getBanner() {
      let datas = {type: 2}
      getGroupList(datas).then(res => {
        this.GroupList = res.data
        if (res.data[0].id) {
          this.group_id = res.data[0].id
          this.GetProductList()
        }
      })
    },
    GetProductList() {
      let datas = {
        group_id: this.group_id,
        name: '',
        page: this.page,
        limit: 6
      }
      getProductMoreList(datas).then(res => {
        res.data.data.map(item => {
          item.chengNum = false
          item.anmintes = false
          if (item.intro.length >= 83) {
            item.clickou = true
          } else {
            item.clickou = false
          }
        })
        this.productList = res.data.data
        this.total = res.data.total
      })
    },
  },
}
</script>

<style scoped lang="less">

.product_brand {
  width: 100%;
  padding-top: 0.1px;

  .product_content {
    margin: 0 auto;

    .Classification {
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      flex-wrap: wrap;

      .ClassificationItem {
        margin-right: 56px;
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #666666;
        min-height: 51px;
        min-width: 108px;
        text-align: center;
        margin-bottom: 5px;
      }

      .activ_line {
        width: 0px;
        height: 0px;
        transition: all 0.5s linear;
        margin: 0 auto;
        border: 2px solid #FFFFFF;
        margin-top: 27px;
      }

      .active_class {
        width: 72px;
        transition: all 0.5s linear;
        border-color: #00AFEF;
      }
    }
    .Classification .ClassificationItem:nth-child(3n){
      //margin-right: 0;
    }
    .cutr_content {
      margin-top: 30px;

      .in_for_tan {
        opacity: 0;
        min-height: 147px;
        background: #F3F3F3;
        margin-bottom: 30px;
        transition: all 0.3s linear;

        .foy_item {
          padding: 34px 29px 17px;
          display: flex;
          position: relative;

          .img_box {
            width: 126px;
            .names {
              font-size: 18px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #333333;
            }

            .txt_lines {
              width: 24px;
              height: 0px;
              border: 2px solid #333333;
              margin: 29px 0 19px;
            }
          }

          .lines {
            width: 0px;
            height: 64px;
            border: 1px solid #707070;
            opacity: 1;
            margin: 0 50px 0 36px;
          }

          .intro {


            .tips {
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              line-height: 28px;
              color: #333333;
              margin-bottom: 15px;
            }

            .intro_mess {
              width: 596px;
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 300;
              line-height: 22px;
              color: #666666;
              -webkit-line-clamp: 2;
              white-space: pre-wrap;


              span:nth-child(1) {
                margin-right: 110px;
              }
            }

            .tuns {
              max-height: 44px;
              transition: all 0.3s linear;
            }

            .active_tuns {
              max-height: 200px;
              -webkit-line-clamp: 8;
              transition: all 0.3s linear;
            }

            .tbs {
              margin-bottom: 5px;
            }
          }

          .see {
            position: absolute;
            right: 39px;
            bottom: 24px;
            display: flex;
            align-items: center;

            img {
              width: 30px;
              height: 30px;
              margin-right: 15px;
            }

            .active_img {
              width: 30px;
              height: 7px;
            }
          }
        }
      }

      .in_for_tan:hover {
        box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.2);
        transition: all 0.3s linear;

        .foy_item {
          .img_box {

            .names {
              color: #0092DD;
            }

            .txt_lines {
              border-color: #0092DD;
            }
          }

          .opctive {
            display: block;
          }
        }
      }
    }

    .block_wap{
      display: none;
    }
    .block_pc{
      display: block;
      margin: 90px auto 140px;
    }
  }


}

@media (max-width: 1200px) {
  .product_brand {
    width: 100%;
    padding-top: 0.1px;

    .product_content {
      margin: 0 auto;

      .Classification {
        .ClassificationItem {
          margin-right: 37px;
          font-size: 13px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #666666;
          min-height: 35px;
          min-width: 63px;
        }

        .activ_line {
          width: 0px;
          height: 0px;
          transition: all 0.5s linear;
          margin: 0 auto;
          border: 1px solid #FFFFFF;
          margin-top: 17px;
        }

        .active_class {
          width: 44px;
          transition: all 0.5s linear;
          border-color: #00AFEF;
        }
      }

      .cutr_content {
        margin-top: 20px;

        .in_for_tan {
          opacity: 1;
          min-height: 111px;
          background: #F3F3F3;
          margin-bottom: 30px;
          transition: all 0.3s linear;

          .foy_item {
            padding: 10px 13px 19px;
            display: flex;
            position: relative;

            .img_box {
              width: 84px;
              .names {
                font-size: 11px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #333333;
              }

              .txt_lines {
                width: 12px;
                height: 0px;
                border: 1px solid #333333;
                margin: 9px 0 5px;
              }
            }

            .lines {
              width: 0px;
              height: 32px;
              border: 1px solid #707070;
              opacity: 1;
              margin: 0 13px 0 16px;
            }

            .intro {
              width: 80%;
              .names {
                font-size: 11px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #333333;
              }

              .txt_lines {
                width: 12px;
                height: 0px;
                border: 1px solid #333333;
                margin: 9px 0 5px;
              }

              .tips {
                font-size: 7px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                line-height: 14px;
                color: #333333;
                margin-bottom: 7px;
              }

              .intro_mess {
                width: 100%;
                font-size: 7px;
                font-family: Microsoft YaHei;
                font-weight: 300;
                line-height: 15px;
                color: #666666;

                white-space: pre-wrap;

                span:nth-child(1) {
                  margin-right: 30px;
                }
              }
              .tuns {
                max-height: 80px;
                -webkit-line-clamp: 5;
                transition: all 0.3s linear;
              }

              .active_tuns {
                max-height: 200px;
                -webkit-line-clamp: 12;
                transition: all 0.3s linear;
              }


              .tbs {
                margin-bottom: 5px;
              }
            }

            .see {
              position: absolute;
              right: 10px;
              bottom: 6px;
              display: flex;
              align-items: center;

              img {
                width: 11px;
                height: 11px;
                margin-right: 4px;
              }

              .active_img {
                width: 11px;
                height: 3px;
              }
            }
          }
        }

        .in_for_tan:hover {
          box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.2);
          transition: all 0.3s linear;

          .foy_item {
            .img_box {
              .names {
                color: #0092DD;
              }

              .txt_lines {
                border-color: #0092DD;
              }
            }
          }
        }
      }

      .block_wap{
        display: block;
        margin: 30px auto 50px;
      }
      .block_pc{
        display: none;
      }
    }
  }
}

</style>